(() => {
  function init(root) {
    if (!root || root.dataset.frReady === '1') return;
    root.dataset.frReady = '1';
    const hero = root.querySelector('.fr-offer__main-image');
    const buttons = [...root.querySelectorAll('[data-fr-thumb]')];
    const current = root.querySelector('[data-fr-slide]');
    let active = 0;
    function showImage(index) {
      if (!hero || !buttons.length) return;
      active = (index + buttons.length) % buttons.length;
      const b = buttons[active];
      if (hero.dataset.frOriginalSizes) {
        hero.removeAttribute('srcset');
        hero.removeAttribute('sizes');
      }
      hero.src = b.dataset.src;
      hero.alt = b.dataset.alt || hero.alt;
      buttons.forEach((item, i) => item.setAttribute('aria-pressed', String(i === active)));
      if (current) current.textContent = String(active + 1);
      const rail = root.querySelector('.fr-offer__thumbs');
      if (rail) {
        const offset = b.offsetLeft - buttons[0].offsetLeft - Math.max(0, (rail.clientWidth - b.clientWidth) / 2);
        rail.scrollTo({left:offset,behavior:'smooth'});
      }
    }
    if (hero && hero.hasAttribute('srcset')) hero.dataset.frOriginalSizes = '1';
    buttons.forEach((button, index) => button.addEventListener('click', () => showImage(index)));
    const gallery = root.querySelector('.fr-offer__image-wrap');
    let touchX = null;
    gallery?.addEventListener('touchstart', event => {touchX = event.touches[0]?.clientX ?? null;}, {passive:true});
    gallery?.addEventListener('touchend', event => {
      if (touchX === null) return;
      const dx = (event.changedTouches[0]?.clientX ?? touchX) - touchX;
      touchX = null;
      if (Math.abs(dx) > 45) showImage(active + (dx < 0 ? 1 : -1));
    }, {passive:true});
    const form = root.querySelector('form.fr-offer__form');
    const price = root.querySelector('[data-fr-price]');
    const sticky = document.querySelector('[data-fr-sticky="' + root.dataset.frId + '"]');
    const anchor = root.querySelector('[data-fr-main-buy]');
    function updatePrice() {
      const selected = form?.querySelector('input[name="id"]:checked');
      if (!selected) return;
      const shown = selected.closest('.fr-pack')?.querySelector('[data-fr-pack-price]')?.textContent?.trim() || '';
      if (price && shown) price.textContent = shown;
      const stickyPrice = sticky?.querySelector('[data-fr-sticky-price]');
      if (stickyPrice && shown) stickyPrice.textContent = shown;
    }
    form?.querySelectorAll('input[name="id"]').forEach(input => input.addEventListener('change', updatePrice));
    updatePrice();
    if (sticky && anchor) {
      let queued = false;
      function updateSticky() {
        queued = false;
        const alreadyPassed = anchor.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', alreadyPassed);
      }
      function onScroll() {
        if (!queued) { queued = true; requestAnimationFrame(updateSticky); }
      }
      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', onScroll, {passive:true});
      updateSticky();
      sticky.querySelector('button')?.addEventListener('click', () => {
        anchor.scrollIntoView({behavior:'smooth',block:'center'});
      });
    }
  }
  function start(context) { (context || document).querySelectorAll('[data-fr-offer]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
